//sliders
let initThumbSlider = () => {
  return new Swiper('.newproduct__gallery__thumb', {
    spaceBetween: 16,
    slidesPerView: 7,
    freeMode: true,
    watchSlidesProgress: true,
    direction: 'vertical',
  });
};
let initFullSlider = (thumbSlider) => {
  return new Swiper('.newproduct__gallery__full', {
    spaceBetween: 10,
    zoom: true,
    lazy: true,
    navigation: {
      nextEl: '.entypo-chevron-small-right',
      prevEl: '.entypo-chevron-small-left',
    },
    thumbs: { swiper: thumbSlider },
    autoHeight: true,
  });
};
let thumbSlider = initThumbSlider();
let fullSlider = initFullSlider(thumbSlider);

//comparison
let beers = document.querySelectorAll('.beer-slider');
beers.forEach((beer) => {
  new BeerSlider(beer, { start: 50 });
});

//variant switch
let paletteInputs = document.querySelectorAll('input[name="palette-choice"]');
let handlePaletteChange = () => {
  const input = event.target;
  if(input._lock) return;
  input._lock = true;
  setTimeout(() => { input._lock = false; }, 150);
  const value = input.value;
  console.log('variant_change', value)
  const activePalette = document.querySelector('.clio-palette-selector li.active');
  if(activePalette) { activePalette.classList.remove('active'); }
  const newActivePalette = input.closest('li');
  if(newActivePalette) { newActivePalette.classList.add('active'); }
  const variantInput = document.querySelector('.single-option-selector');
  if(variantInput) {
    if(variantInput.nodeName !== "SELECT") {
      variantInput.value = value;
    } else {
      variantInput.value = value;
      Array.from(variantInput.options).forEach(opt => { opt.selected = (opt.value === value); });
      variantInput.selectedIndex = Array.from(variantInput.options).findIndex(opt => opt.value === value);
    }
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const visibleSlides = document.querySelectorAll('.swiper [data-filter="' + value + '"]');
  const hiddenSlides = document.querySelectorAll('.swiper [data-filter]:not([data-filter=""]):not([data-filter="' + value + '"])');
  hiddenSlides.forEach((hiddenSlide) => {
    hiddenSlide.classList.add('non-swiper-slide');
    hiddenSlide.classList.remove('swiper-slide');
    hiddenSlide.removeAttribute('style');
  });
  visibleSlides.forEach((visibleSlide) => {
    visibleSlide.classList.remove('non-swiper-slide');
    visibleSlide.classList.add('swiper-slide');
    visibleSlide.removeAttribute('style');
  });
  thumbSlider.destroy();
  fullSlider.destroy();
  thumbSlider = initThumbSlider();
  fullSlider = initFullSlider(thumbSlider);
  window.dispatchEvent(new Event('resize'));
}
paletteInputs.forEach((paletteInput) => {
  ['change', 'click', 'input'].forEach(ev => { paletteInput.addEventListener(ev, handlePaletteChange); });
  if(paletteInput.checked) { paletteInput.dispatchEvent(new Event('change')); }
});

//related addtocart
document.addEventListener('DOMContentLoaded', () => {
  let relatedButtons = document.querySelectorAll(
    '.newproduct__crossell button'
  );
  relatedButtons.forEach((relatedButton) => {
    relatedButton.addEventListener('click', (e) => {
      e.preventDefault();
      relatedButton.classList.add('loading');
      const variant = relatedButton.previousElementSibling.value;
      const formData = { items: [{ id: variant, quantity: 1 }] };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((response) => {
          const event = new Event('linkRecentCartItemPopUp');
          window.dispatchEvent(event);
          relatedButton.classList.remove('loading');
        })
        .catch((error) => {
          const event = new Event('linkAddToCartFail');
          window.dispatchEvent(event);
          relatedButton.classList.remove('loading');
        });
    });
  });
});

//utm messages
let utmMessages = () => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source');
  const messages = document.querySelectorAll('[data-utm="' + source + '"]');
  messages.forEach((message) => {
    const content = message.getAttribute('data-utm-content');
    if (content) {
      message.removeAttribute('data-utm-content');
      message.innerText = content;
      message.style.display = 'block';
    }
  });
};
utmMessages();

document.addEventListener('DOMContentLoaded', () => {
  //sticky addtocart
  const sentinelEl = document.querySelector('.newproduct__addtocart__sentinel');
  if (sentinelEl) {
    const headerEl = sentinelEl.querySelector('.newproduct__addtocart');
    if (window.innerWidth < 768) {
      headerEl.classList.toggle('stuck', 1);
      headerEl.classList.toggle('animate', 1);
    }
    sentinelEl.style.minHeight = headerEl.offsetHeight + 'px';
    const observer = new window.IntersectionObserver((entries) => {
      //var fromtop = sentinelEl.getBoundingClientRect().top
      //console.log(fromtop, entries[0].isIntersecting)
      headerEl.classList.toggle('stuck', !entries[0].isIntersecting);
      setTimeout(function () {
        headerEl.classList.toggle('animate', !entries[0].isIntersecting);
      }, 150);
    });
    observer.observe(sentinelEl);
  }

  //video playback
  const videos = document.querySelectorAll('.newproduct__focus-media video');
  videos.forEach((video) => {
    const pause = video.nextElementSibling;
    const mute = pause.nextElementSibling;
    pause.addEventListener('click', () => {
      if (video.paused || video.ended) {
        video.play();
        pause.setAttribute('class', 'entypo-controller-paus');
      } else {
        video.pause();
        pause.setAttribute('class', 'entypo-controller-play');
      }
    });
    mute.addEventListener('click', () => {
      video.muted = !video.muted;
      mute.setAttribute(
        'class',
        video.muted ? 'fa-controller-volume-up' : 'fa-controller-volume-off'
      );
    });
  });

  //cards sliders
  const cardsliders = document.querySelectorAll(
    '.newproduct__cardslider .swiper'
  );
  const nextNextprevPrevSlides = (swiper, cardslider) => {
    const previousSlides = cardslider.querySelectorAll(
      '.swiper-slide-next-next, .swiper-slide-prev-prev'
    );
    const previousFlipped = cardslider.querySelector('.flip.flipped');
    if (previousFlipped) {
      previousFlipped.classList.remove('flipped');
    }
    previousSlides.forEach((previousSlide) => {
      previousSlide.classList.remove('swiper-slide-next-next');
      previousSlide.classList.remove('swiper-slide-prev-prev');
    });
    const active =
      cardslider.querySelectorAll('.swiper-slide')[swiper.activeIndex];
    const nextNext = active.nextElementSibling?.nextElementSibling;
    const prevPrev = active.previousElementSibling?.previousElementSibling;
    if (nextNext) {
      nextNext.classList.add('swiper-slide-next-next');
    }
    if (prevPrev) {
      prevPrev.classList.add('swiper-slide-prev-prev');
    }
  };
  cardsliders.forEach((cardslider) => {
    const flipButtons = cardslider.querySelectorAll('button');
    flipButtons.forEach((flipButton) => {
      const flipContainer = flipButton.closest('.flip');
      flipButton.addEventListener('click', (e) => {
        e.preventDefault();
        flipContainer.classList.toggle('flipped');
      });
    });
    new Swiper(cardslider, {
      effect: 'cards',
      slideToClickedSlide: true,
      cardsEffect: {
        perSlideOffset: 10,
        perSlideRotate: 2,
        rotate: true,
        slideShadows: false,
      },
      lazy: true,
      slidesPerView: 1,
      autoHeight: true,
      breakpoints: {
        768: { cardsEffect: { perSlideOffset: 5 } },
        1024: { cardsEffect: { perSlideOffset: 30 } },
        1200: { cardsEffect: { perSlideOffset: 45 } },
      },
      on: {
        init: (swiper) => {
          nextNextprevPrevSlides(swiper, cardslider);
        },
        activeIndexChange: (swiper) => {
          nextNextprevPrevSlides(swiper, cardslider);
        },
      },
    });
  });

  //dialog
  const dialogs = document.querySelectorAll('.newpage dialog');
  dialogs.forEach((dialog) => {
    const link = dialog.previousElementSibling;
    const close = dialog.querySelector('.close');
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.innerWidth < 768) {
        dialog.classList.toggle('open');
      } else {
        dialog.showModal();
      }
    });
    dialog.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.innerWidth > 767) {
        dialog.close();
      }
    });
  });
});
